import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        this.GetInfo();

    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,

            Info: [],
            Statistics: [],
            

         


        };
    },



    methods: {




        GetInfo() {
            this.$blockUI.Start();
            this.$http.GetMyFarmes(this.pageNo, this.pageSize, this.Search)
                .then(response => {

                    this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

    }
}
